<div class="invoice-container">
  <!-- Left section for branding and instructions -->
  <aside class="sidebar">
    <div class="sidebar-content">
      <a routerLink="/home" class="logo-container" title="Go to Home">
        <img src="../assets/images/logo.svg" alt="Inforida Logo" class="logo" />
      </a>
      <div class="invoice-content">
        <div class="invoice-image-container">
          <img class="invoice-image"
            src="https://cdn.dribbble.com/users/4908/screenshots/2787171/media/a54da5ba89330cf4804a4d7b21012067.gif"
            alt="Invoice Banner" />
        </div>
        <div>
          <h1 class="invoice-heading">GST Invoice Generator</h1>
        </div>
        <div>
          <h2 class="invoice-text">
            AI-powered invoice generator with <br>
            Automatic HSN & Dynamic GST rates,<br>
            Effortless, Reliable & 100 % Secure.<br>
          </h2>
        </div>

      </div>
    </div>
    <div class="gst-notifications">
      <h3>Important Links</h3>
      <div class="notification-links">
        <a href="https://www.gst.gov.in/" target="_blank">GST Portal</a> |
        <a href="https://taxinformation.cbic.gov.in/content-page/explore-act" target="_blank">GST Act</a> |
        <a href="https://taxinformation.cbic.gov.in/content-page/explore-instructions" target="_blank">GST
          Guidelines</a> |
        <a href="https://taxinformation.cbic.gov.in/content-page/explore-notification" target="_blank">GST
          Notifications</a> |
        <a href="https://taxinformation.cbic.gov.in/content-page/explore-rules" target="_blank">GST Rules</a> |
        <a href="https://taxinformation.cbic.gov.in/content-page/explore-forms" target="_blank">GST Forms</a> |
        <a href="https://taxinformation.cbic.gov.in/content-page/explore-circulars" target="_blank">GST Circulars</a> |
        <a href="https://www.cbic.gov.in/entities/gst" target="_blank">GST Rules on CBIC</a> |
        <a href="https://taxinformation.cbic.gov.in/" target="_blank">Tax Information Portal</a>
      </div>
    </div>
    <div class="made-with-love">
      <p>Made With ❤️ In India</p>
    </div>
  </aside>



  <!-- Right section for the main form content -->
  <main class="form-container">
    <form [formGroup]="invoiceForm" (ngSubmit)="onSubmit()">

      <section class="upload-section">
        <label>Upload Business Logo</label>
        <div class="upload-actions">

          <!-- Hidden File Input for Uploading the Logo -->
          <button *ngIf="!uploadedLogoUrl" mat-stroked-button color="primary" (click)="triggerFileUpload()"
            type="button">
            <mat-icon>upload</mat-icon> Upload
          </button>
          <div *ngIf="uploadedLogoUrl" class="logo-preview">
            <img [src]="uploadedLogoUrl" alt="Invoice Logo" class="uploaded-logo" />
            <button mat-stroked-button color="warn" (click)="resetLogo()" type="button">
              <mat-icon>refresh</mat-icon> Reset Logo
            </button>
          </div>
        </div>
        <input type="file" #fileInput accept="image/*" (change)="onFileUpload($event)" style="display: none;" />
        <mat-progress-spinner *ngIf="isUploading" diameter="30" mode="indeterminate"></mat-progress-spinner>

      </section>

      <!-- Basic Invoice Information -->
      <section class="form-section">
        <div class="form-row">

          <!-- Invoice Date Field with Hint -->
          <mat-form-field appearance="outline" class="form-field one-third">
            <mat-label>Invoice Date</mat-label>
            <input matInput [matDatepicker]="picker" placeholder="Select date" formControlName="invoiceDate" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="invoiceForm.get('invoiceDate')?.hasError('required')">Date is required.</mat-error>
          </mat-form-field>

          <!-- Invoice Number Field with Hint and Error -->
          <mat-form-field appearance="outline" class="form-field one-third">
            <mat-label>Invoice Number</mat-label>
            <input matInput placeholder="Enter invoice number" formControlName="invoiceNumber" />
            <mat-error *ngIf="invoiceForm.get('invoiceNumber')?.hasError('required')">Invoice no is
              required.</mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">

          <!-- Business Name Field with Error -->
          <mat-form-field appearance="outline" class="form-field full-width">
            <mat-label>Business Name</mat-label>
            <input matInput placeholder="Enter supplier name" formControlName="supplierName" />
            <mat-error *ngIf="invoiceForm.get('supplierName')?.hasError('required')">
              Business name is required.
            </mat-error>
          </mat-form-field>

          <!-- Supplier Address Field with Hint -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Address</mat-label>
            <input matInput placeholder="Enter supplier address" formControlName="supplierAddress" />
            <mat-hint *ngIf="invoiceForm.get('supplierAddress')?.untouched">Provide the complete address.</mat-hint>
          </mat-form-field>

          <!-- State Dropdown with Error -->
          <mat-form-field appearance="outline" class="one-third">
            <mat-label>State</mat-label>
            <mat-select formControlName="supplierState">
              <mat-option *ngFor="let state of states" [value]="state">{{ state }}</mat-option>
            </mat-select>
            <mat-error *ngIf="invoiceForm.get('supplierState')?.hasError('required')">State is required.</mat-error>
          </mat-form-field>

          <!-- GSTIN Field with Hint and Error -->
          <mat-form-field appearance="outline" class="form-field one-third">
            <mat-label>GSTIN</mat-label>
            <input matInput placeholder="Enter supplier GSTIN" formControlName="supplierGstin" />
            <mat-hint *ngIf="!invoiceForm.get('supplierGstin')?.valid && invoiceForm.get('supplierGstin')?.touched">
              A valid GSTIN is required.
            </mat-hint>
            <mat-error *ngIf="invoiceForm.get('supplierGstin')?.hasError('pattern')">
              A valid GSTIN is required.
            </mat-error>
            <mat-error *ngIf="invoiceForm.get('supplierGstin')?.hasError('required')">GSTIN is required.</mat-error>
          </mat-form-field>

          <!-- PAN Field with Hint and Error -->
          <mat-form-field appearance="outline" class="form-field one-third">
            <mat-label>PAN</mat-label>
            <input matInput placeholder="Enter supplier PAN" formControlName="supplierPan" />
            <mat-hint *ngIf="!invoiceForm.get('supplierPan')?.valid && invoiceForm.get('supplierPan')?.touched">
              A valid PAN is required.
            </mat-hint>
            <mat-error *ngIf="invoiceForm.get('supplierPan')?.hasError('pattern')">
              A valid PAN is required.
            </mat-error>
            <mat-error *ngIf="invoiceForm.get('supplierPan')?.hasError('required')">PAN is required.</mat-error>
          </mat-form-field>
        </div>
      </section>


      <hr style="margin: 24px 0px 24px 0px;">


      <!-- Customer Information, grouped for compact display -->
      <section class="form-section">
        <h3>Customer Details</h3>
        <div class="form-row">

          <!-- Customer Name Field with Error -->
          <mat-form-field appearance="outline" class="form-field full-width">
            <mat-label>Customer Name</mat-label>
            <input matInput placeholder="Enter customer name" formControlName="customerName" />
            <mat-error *ngIf="invoiceForm.get('customerName')?.hasError('required')">Customer name is
              required.</mat-error>
          </mat-form-field>

          <!-- Customer Address Field with Hint -->
          <mat-form-field appearance="outline" class="form-field full-width">
            <mat-label>Customer Address</mat-label>
            <input matInput placeholder="Enter customer address" formControlName="customerAddress" />
            <mat-hint *ngIf="invoiceForm.get('customerAddress')?.untouched">Provide the complete address.</mat-hint>
          </mat-form-field>

          <!-- Customer State Dropdown with Error -->
          <mat-form-field appearance="outline" class="one-third">
            <mat-label>Customer State</mat-label>
            <mat-select formControlName="customerState">
              <mat-option *ngFor="let state of states" [value]="state">{{ state }}</mat-option>
            </mat-select>
            <mat-error *ngIf="invoiceForm.get('customerState')?.hasError('required')">
              State selection is required.
            </mat-error>
          </mat-form-field>

          <!-- Customer GSTIN Field with Hint and Error -->
          <mat-form-field appearance="outline" class="form-field one-third">
            <mat-label>Customer GSTIN</mat-label>
            <input matInput placeholder="Enter customer GSTIN" formControlName="customerGstin" />
            <mat-hint *ngIf="!invoiceForm.get('customerGstin')?.valid && invoiceForm.get('customerGstin')?.touched">
              A valid GSTIN is required.
            </mat-hint>
            <mat-error *ngIf="invoiceForm.get('customerGstin')?.hasError('pattern')">
              A valid GSTIN is required.
            </mat-error>
            <mat-error *ngIf="invoiceForm.get('customerGstin')?.hasError('required')">GSTIN is required.</mat-error>
          </mat-form-field>

          <!-- Customer PAN Field with Hint and Error -->
          <mat-form-field appearance="outline" class="form-field one-third">
            <mat-label>Customer PAN</mat-label>
            <input matInput placeholder="Enter customer PAN" formControlName="customerPan" />
            <mat-hint *ngIf="!invoiceForm.get('customerPan')?.valid && invoiceForm.get('customerPan')?.touched">
              A valid PAN is required.
            </mat-hint>
            <mat-error *ngIf="invoiceForm.get('customerPan')?.hasError('pattern')">
              A valid PAN is required.
            </mat-error>
            <mat-error *ngIf="invoiceForm.get('customerPan')?.hasError('required')">PAN is required.</mat-error>
          </mat-form-field>
        </div>
      </section>



      <hr style="margin: 24px 0px 24px 0px;">


      <!-- Invoice Items Section -->
      <section class="form-section" [formArrayName]="'items'">
        <div class="form-row" style="margin-bottom: 16px;">
          <h3>List of Items</h3>
          <button mat-stroked-button (click)="addItem()" color="primary" type="button" class="add-item-button">
            <mat-icon>add_circle</mat-icon> Add Item
          </button>
        </div>

        <div *ngFor="let item of items.controls; let i = index" [formGroupName]="i" class="item-row">
          <div class="gst-info-container">
            <span *ngIf="item.get('gstTypeHint')?.value" [ngClass]="getGstChipClass(item.get('gst')?.value)">
              {{ item.get('gstTypeHint')?.value }} ({{ item.get('gst')?.value }}%)
            </span>
          </div>
          <div class="form-fields">
            <mat-form-field appearance="outline" class="form-field half-width">
              <mat-label>Item Name</mat-label>
              <input matInput placeholder="Enter item name" formControlName="description" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field half-width">
              <mat-label>HSN/SAC Code</mat-label>
              <input matInput placeholder="Enter HSN/SAC code" formControlName="hsnSac" />
              <mat-hint *ngIf="item.get('gstTypeHint')?.value">
                {{ item.get('gstTypeHint')?.value }}
              </mat-hint>
            </mat-form-field>
          </div>

          <div class="form-fields">
            <mat-form-field appearance="outline" class="form-field one-third-width">
              <mat-label>Price (In Rs.)</mat-label>
              <input matInput type="number" placeholder="Enter price" formControlName="price" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field one-third-width">
              <mat-label>Quantity</mat-label>
              <input matInput type="number" placeholder="Enter quantity" formControlName="quantity" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field one-third-width" readonly>
              <mat-label>GST Rate (%)</mat-label>
              <mat-select formControlName="gst">
                <mat-option *ngFor="let rate of rates" [value]="rate">{{ rate }}%</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Delete Button at the End -->
            <button mat-icon-button color="warn" (click)="removeItem(i)" aria-label="Delete Item" class="delete-button">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </section>

      <section class="form-section">
        <mat-form-field appearance="outline" class="form-field full-width">
          <mat-label>Terms and Conditions</mat-label>
          <textarea matInput placeholder="Enter terms and conditions here..." formControlName="termsAndConditions"
            rows="6"></textarea>
        </mat-form-field>
      </section>




      <!-- Tax Summary Section -->
      <hr style="margin: 24px 0px 24px 0px;">
      <section class="tax-summary">

        <h3>Tax Calculation Summary</h3>
        <div>
          <span>Total Taxable Amount:</span>
          <strong>Rs. {{ taxBreakdown.totalTaxable | number }}</strong>
        </div>
        <div *ngIf="!isInterstate">
          <span>CGST:</span>
          <strong>Rs. {{ taxBreakdown.cgst | number }}</strong>
        </div>
        <div *ngIf="!isInterstate">
          <span>SGST:</span>
          <strong>Rs. {{ taxBreakdown.sgst | number}}</strong>
        </div>
        <div *ngIf="isInterstate">
          <span>IGST:</span>
          <strong>Rs. {{ taxBreakdown.igst | number}}</strong>
        </div>
        <div class="total-amount">
          <span>Total Invoice Amount:</span>
          <strong>Rs. {{ taxBreakdown.totalAmount | number}}</strong>
        </div>
      </section>


      <!-- Terms and Conditions Section -->

    </form>

    <!-- Fixed action bar at the bottom-right corner -->
    <div class="action-bar">
      <button mat-stroked-button color="warn" (click)="resetForm()">
        <mat-icon>refresh</mat-icon>
        Reset
      </button>
      <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!invoiceForm.valid">
        Generate Invoice
      </button>

    </div>
  </main>
</div>